
import i18n from "@/i18n";
import store from "@/store";
import { createTeam, executeGetTeam, executeSaveTeam, getUsersListToCreateManager, searchTeams } from "@/store/services/configuration/teamService";
import { TeamState } from "@/types";
import { deepClone, mountSelectFields, SELECTED_USER_NETWORK, unmountSelectFieldsV2 } from "@/utils";
import Notify from 'quasar/src/plugins/Notify.js';;
import { Module } from "vuex";

const teamModule: Module<TeamState, unknown> = {
  namespaced: true,
  state: {
    selectedTeam:{
        resourceUid: "",
        description : '',
        validity :{ from: "", until: "" },
        manager: {
            type: {
              value: ''
            }
        },
        typeActivity: {
           type: {
              value: '',
            }
        },
        members: [],
        secretary: {
          type: {
            value: ''
          }
         },
        groupAndMembers: [
          {
          group: 
            { value: '', 
              label: '' 
            }
          ,
          members: [],
          membersOptionsList: []
          }
        ]
        },
        networkNode: {
          value: localStorage.getItem(SELECTED_USER_NETWORK),
          label: i18n.global.t(
            `users.networkNode.${localStorage.getItem(SELECTED_USER_NETWORK)}`
          )
        },
    isLoading: false,
  },
  getters: {
    getTeamEmpty() {
        return {
                "objectType": "odm.user.team",
                "systemUid": "odm-user",
                "businessData": null,
                "daaq": "/",
                "description": "",
                "validity": {},
                "manager": {
                    "objectType": "odm.user.leaseforgeuser",
                    "systemUid": "odm-user",
                    "resourceUid": ""
                },
                 "typeActivity": {
                    "objectType": "odm.user.typeactivity",
                    "systemUid": "odm-user",
                    "resourceUid": ""
    },
                "members": [
                ]
            }
      },
      getTeamMemberEmpty() {
        return  {
            "businessData": null,
            "daaq": "/",
            "objectType": "odm.user.teammember",
            "systemUid": "odm-user",
            "validity": {},
            "member": {
                "resourceUid": "",
                "objectType": "odm.user.leaseforgeuser",
                "systemUid": "odm-user"
            },
             "securityGroup": {
                "resourceUid": "",
                "objectType": "odm.user.securitygroup",
                "systemUid": "odm-user"
            }
        }
      },
      getInitialNetworkNode(){
        return  {
          value: localStorage.getItem(SELECTED_USER_NETWORK),
          label: i18n.global.t(
            `users.networkNode.${localStorage.getItem(SELECTED_USER_NETWORK)}`
          )
        }
      },
       getInitGroupAndMembers() {
        return {
                "group" : 
                  {
                      value: '',
                      label: ''
                  },
                "members": [
                ],
                "membersOptionsList": []
            }
      }
   
  },
  actions: {
    usersList({ commit }, payload) {
        const { filter, callback } = payload;
        getUsersListToCreateManager(filter)
          .then((res) => {
            callback(res);
          })
          .catch((e) => console.error(e));
    },
    async saveTeam({ commit }, payload) {
        const { team, callback} = payload
        await executeSaveTeam(team)
                .then((res:any) => {
                    Notify.create({
                        message: i18n.global.t('main.dialog.success', { entity: res.data?.resourceUid }),
                        color: "positive",
                    }) 
                    commit('setTeam', res.data);
                })
                .catch((e:any) => console.error(e))
      },
      async getTeam({ commit }, payload) {
       await executeGetTeam(payload)
                .then((res:any) => {
                    commit('setTeam', res.data);
                })
                .catch((e:any) => console.error(e))
      },

     setNetworkNode({ commit }, payload) {
        commit('setNetworkNode',payload);
    },
      cleanTeam({ commit }, payload) {
        commit('setInitial');
    },
    searchTeams({ commit }, payload) {
      const { filter,offset,limit, callback } = payload;
      searchTeams(filter,offset,limit)
        .then((res) => {
          callback(res);
        })
        .catch((e) => console.error(e));
    },
    addGroupAndMembers ({ commit }, payload) {
      commit("addGroupAndMembers", payload);
    }
  },
  mutations: {
    setInitial(state) {
        state.selectedTeam = {
            resourceUid: "",
            description : '',
            validity :{ from: "", until: "" },
            manager: {
                type: {
                value: ''
                }
            },
            typeActivity: {
                type: {
                value: ''
                }
            },
            members: [],
            secretary: {
              type: {
                value: ''
              }
            },
            groupAndMembers: [
            {
            group: 
              { value: '', 
                label: '' 
              },
            members: [],
            membersOptionsList: []
            }
           ]
        }
        state.networkNode = deepClone(store.getters["teamModule/getInitialNetworkNode"])
    },
    setTeam(state, payload) {
        state.selectedTeam = payload
    },
    setNetworkNode(state, payload) {
        state.networkNode = payload
    },
    addGroupAndMembers(state, payload) {
      state.selectedTeam.groupAndMembers.push(payload);
    }
 },
};

export default teamModule;
